import type { CSSProperties } from 'react';

/** Matches legacy `Btn` geometry (padding 9×20, 16/22 type) vs DS default min-height 40px. */
export const TABLE_LEGACY_BUTTON_STYLE: CSSProperties = {
  minHeight: 'unset',
  padding: '9px 20px',
  fontSize: '16px',
  lineHeight: '22px',
};

export const TABLE_SCROLL_FOOTER_STYLE: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '16px 0',
  position: 'sticky',
  left: 0,
};
